var React = require('react');

function House (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"8.5,0.4 0,8 2,8 2,14 7,14 7,9 10,9 10,14 15,14 15,8 17,8 "}));
}

House.defaultProps = {"version":"1.1","x":"0px","y":"0px","width":"17px","height":"14px","viewBox":"0 0 17 14","enableBackground":"new 0 0 17 14","xmlSpace":"preserve"};

module.exports = House;

House.default = House;
